import { Link } from 'react-router-dom';

export function Footer() {
  return (
    <footer className="clean-footer crev">
      <div className="container pb-40 pt-40 ontop">
        <div className="row justify-content-between">
          <div className="col-lg-3 md-mb80">
            <div className="logo icon-img-100">
              <div className="elenardTextLogo">
                Elena <span className="fw-200">RD</span>
              </div>
            </div>
            <div className="mt-20">
              <h6 className="p-color fw-400">
                Art jewelry &amp; accessories for hair, dreads, locs and braids.
              </h6>
            </div>
          </div>

          <div className="col-lg-3">
            <div className="column md-mb50">
              <h6 className="sub-title mb-30">Menu</h6>
              <ul className="rest fz-14 opacity-7">
                <li className="mb-15">
                  <Link to="/">Home</Link>
                </li>
                <li className="mb-15">
                  <Link to="/shop">Shop Online</Link>
                </li>
                <li className="mb-15">
                  <Link to="/wishlist">Wishlist</Link>
                </li>
                <li className="mb-15">
                  <Link to="/contact">Contact Us</Link>
                </li>
                <li className="mb-15">
                  <Link to="/policy/privacy">Privacy Policy</Link>
                </li>
                <li>
                  <Link to="/policy/store">Store Policy</Link>
                </li>
              </ul>
            </div>
          </div>

          <div className="col-lg-5">
            <div className="column subscribe-minimal">
              <h6 className="sub-title mb-15">Newsletter for update &amp; offer</h6>
              <h6 className="p-color fw-400">
                We’ll use this email list only to notify you about release dates
                for ready-to-ship jewelry
              </h6>
              <form
                className="elenardFooterNewsletter"
                onSubmit={(e) => e.preventDefault()}
              >
                <div className="form-group mb-0 mt-30 elenardFooterNewsletterRow">
                  <input
                    id="newsletterEmail"
                    type="email"
                    name="subscrib"
                    placeholder="Enter your email address..."
                    required
                  />
                  <button className="elenardSubscribeBtn" type="submit">
                    Subscribe
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>

        <div className="pt-30 pb-30 mt-80 bord-thin-top">
          <div className="text-center">
            <p className="fz-14">
              © 2025 Elena RD art jewelry &amp; accessories All rights reserved.
              Designed by Plenitude IT
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}

